import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const CHECKBOX_DISPLAY_BOX = "checkbox";
export const CHECKBOX_DISPLAY_CARET = "caret";

export default class CheckboxDisplay extends BaseOption {
  static userInterfaceComponent = {
    label: "Control",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      placeholder: `${CHECKBOX_DISPLAY_BOX} or ${CHECKBOX_DISPLAY_CARET}`,
    },
  };

  static defaultValue = CHECKBOX_DISPLAY_BOX;
}
